import { render, staticRenderFns } from "./ImportClientData.vue?vue&type=template&id=9a65d10c&"
import script from "./ImportClientData.vue?vue&type=script&lang=js&"
export * from "./ImportClientData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports